import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { RoutalPlaceIcon } from '../../../../assets/svg/RoutalPlaceIcon';
import { SurveyDistanceIcon } from '../../../../assets/svg/survey/SurveyDistanceIcon';
import { SurveyTimeIcon } from '../../../../assets/svg/survey/SurveyTimeIcon';
import { getMarkerStatusColor } from '../../../../constants/Colors';
import { STOP_STATUS } from '../../../../constants/Stops';
import { DistanceType } from '../../../../domain/driversProject/DriversProject';
import { Route } from '../../../../domain/route/Route';
import { kmToSM } from '../../../../helpers/Units';
import { useRetrieveVehicle } from '../../hooks/useRetrieveVehicle';
import { RouteCompletedChip } from './RouteCompletedChip';

interface RouteCompletedStatsProps {
  selectedRoute: Route;
}

export const RouteCompletedStats = ({ selectedRoute }: RouteCompletedStatsProps) => {
  const { data: vehicleData } = useRetrieveVehicle();
  const completedStops = selectedRoute.stops.filter((stop) => stop.status === STOP_STATUS.completed).length;
  const canceledStops = selectedRoute.stops.filter((stop) => stop.status === STOP_STATUS.canceled).length;
  // const incompleteStops = selectedRoute.stops.filter((stop) => stop.status === STOP_STATUS.incomplete).length;

  const differenceInMilliseconds =
    selectedRoute.start_date && selectedRoute.end_date
      ? new Date(selectedRoute.end_date).getTime() - new Date(selectedRoute.start_date).getTime()
      : 0;

  // If you want the difference in seconds
  const differenceInSeconds = differenceInMilliseconds / 1000;

  // If you want the difference in minutes
  const differenceInMinutes = differenceInSeconds / 60;

  // If you want the difference in hours
  const differenceInHours = differenceInMinutes / 60;

  // Format the difference as "(hours)h (min)m"
  const formattedDifference = `${Math.floor(differenceInHours)}h ${Math.floor(differenceInMinutes % 60)}m`;

  const results = [
    // {
    //   title: `driver.stops.congratulations.total_stops`,
    //   value: selectedRoute.stops.length.toString(),
    //   icon: <FmdGoodOutlinedIcon style={{ color: RoutalPalette.grey7 }} />,
    //   color: RoutalPalette.grey7,
    // },
    {
      title: `driver.stops.congratulations.completed`,
      value: completedStops.toString(),
      icon: <RoutalPlaceIcon color={getMarkerStatusColor(STOP_STATUS.completed, `medium`)} />,
      color: getMarkerStatusColor(STOP_STATUS.completed, `medium`),
    },
    {
      title: `driver.stops.congratulations.canceled`,
      value: canceledStops.toString(),
      icon: <RoutalPlaceIcon color={getMarkerStatusColor(STOP_STATUS.canceled, `medium`)} />,
      color: getMarkerStatusColor(STOP_STATUS.canceled, `medium`),
    },
    // {
    //   title: `driver.stops.congratulations.incomplete`,
    //   value: incompleteStops.toString(),
    //   icon: <FmdGoodOutlinedIcon style={{ color: getMarkerStatusColor(STOP_STATUS.incomplete, `medium`) }} />,
    //   color: getMarkerStatusColor(STOP_STATUS.incomplete, `medium`),
    // },
    {
      title: `driver.stops.congratulations.route_time`,
      value: formattedDifference,
      icon: <SurveyTimeIcon style={{ color: RoutalPalette.secondary20 }} />,
      color: RoutalPalette.secondary20,
    },
    {
      title: `driver.stops.congratulations.distance`,
      value: `${kmToSM(
        (selectedRoute.distance_traveled ?? 0) / 1000, // Convert meters to kilometers
        vehicleData?.project.units.distance as DistanceType
      )} ${vehicleData?.project.units.distance ?? `km`}`,
      icon: <SurveyDistanceIcon style={{ color: RoutalPalette.secondary20 }} />,
      color: RoutalPalette.secondary20,
    },
  ];

  return (
    <Grid
      style={{
        display: `flex`,
        width: `100%`,
        height: `100%`,
        flexWrap: `nowrap`,
        justifyContent: `space-between`,
        flexDirection: `column`,
      }}
    >
      {results.map((result, index) => (
        <RouteCompletedChip
          key={index}
          intIdTitle={result.title}
          value={result.value}
          icon={result.icon}
          color={result.color}
        />
      ))}
    </Grid>
  );
};
